export const trackAnalyticsEvent = (category, action, label) => {
  if (typeof trackEvent === 'function') {
    // function 'trackEvent' is attached to the window by ruby
    trackEvent(category, action, label);
  }
};

export const updateAnalyticsConfiguration = (pathname, query) => {
  if (typeof window.gtag === 'function') {
    const pagePath = `${pathname}${query}`;

    window.gtag('config', 'UA-96951677-1', {
      page_path: pagePath
    });

    window.gtag('config', 'AW-715672677', {
      page_path: pagePath
    });
  }
};



// WEBPACK FOOTER //
// ./app/javascript/services/analytics.js